import { CardActionArea as MuiCardActionArea, Grid } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { formatItem } from "@framework/exchange";
import { StyledCardContentDescription, StyledCardMedia } from "@framework/styled";
import type { IProduct } from "@framework/types";
import { RichTextDisplay } from "@dzambalaorg/mui-rte";
import { Card, Typography } from "@dzambalaorg/ui-kit";

import { AmountInput } from "../../../../components/inputs/amount";

interface IProductItemProps {
  product: IProduct;
}

export const ProductItem = (props: IProductItemProps) => {
  const { product } = props;

  return (
    <Card>
      <MuiCardActionArea component={RouterLink} to={`/ecommerce/products/${product.id}`}>
        <StyledCardMedia image={product.photos[0].imageUrl} title={product.photos[0].title} />
        <Card.Header>
          <Typography variant="h5" component="h2">
            {product.title}
          </Typography>
          <StyledCardContentDescription>
            <RichTextDisplay data={product.description} />
          </StyledCardContentDescription>
          <Typography variant="body2" color="textSecondary" component="p">
            {formatItem(product.productItems[0].price)}
          </Typography>
        </Card.Header>
      </MuiCardActionArea>
      <Card.Footer>
        <Grid container alignItems="center">
          <AmountInput product={product} />
        </Grid>
      </Card.Footer>
    </Card>
  );
};
